var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistorySend = function SvgHistorySend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M14.376 7.568 7.63 1.712a.3.3 0 0 0-.188-.07h-1.58a.142.142 0 0 0-.093.25l6.254 5.43H1.573a.143.143 0 0 0-.143.142v1.071c0 .079.064.143.143.143H12.02l-6.254 5.429c-.1.087-.04.25.093.25h1.634a.14.14 0 0 0 .093-.036l6.79-5.89a.573.573 0 0 0 0-.863"
  })));
};
export default SvgHistorySend;